import * as Sentry from '@sentry/react';

// Gracefully inert without a DSN — nothing to configure for local dev, and no
// requests fire until REACT_APP_SENTRY_DSN is actually set (see docs/... at
// deploy time). Mirrors the backend's errorReporting.js no-op-until-configured
// pattern used throughout this app for optional infra (GCS, Change Streams).
let initialized = false;

export function initErrorReporting() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || initialized) return;
  initialized = true;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    // Keep this lean on purpose: error capture only, no session replay or
    // performance tracing — those add real bundle size and network overhead
    // for a wedding-invitation SPA where "did an error happen" is what matters.
    integrations: [],
    tracesSampleRate: 0,
  });
}

export function captureException(error, extra) {
  if (!initialized) return;
  try {
    Sentry.captureException(error, extra ? { extra } : undefined);
  } catch (_) {
    // Reporting failures must never break the app itself.
  }
}
